import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as Arrow } from '../../assets/dropdown-arrow.svg'
import { useViewport } from '../../hooks/responsive'
import './selectorList.less'

interface Props {
  onChange: (value: string) => void
  value?: string
  options: string[]
}

const SelectorList: React.FC<Props> = ({ options, value, onChange }: Props) => {
  const { t } = useTranslation()
  const [expandedDocumentList, setExpendedDocumentList] = useState(false)
  const {isMobile} = useViewport()

  const onOptionSelect = (item: string) => {
    onChange(item)
    setTimeout(() => setExpendedDocumentList(false), 10)
  }

  return (
    <div className={isMobile ? 'selector-list-mobile' : 'selector-list'}>
      <div className={`${isMobile ? 'input-field-mobile': 'input-field'} selector-list-field`} onClick={() => setExpendedDocumentList(!expandedDocumentList)}>
        <div className="selector-text-field">{value ? t(value) : ''}</div>
        <div className="icon-arrow">
          <Arrow />
        </div>
      </div>
      {expandedDocumentList && (
        <div className="selector-list-options">
          {options.map((item: string) => (
            <div key={item} onClick={() => onOptionSelect(item)} className={`selector-list-option ${item}`}>
              {t(item)}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
export default SelectorList
